import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ProjectBasicInfo from '../../../widgets/projectBasicInfo/ProjectBasicInfo'
import { Panel, Row, Col, Grid, Input, Button } from 'rsuite'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { getProjectApprovalSummaryForStaff } from '../../../redux/actions/projectApprovalSummaryForStaff'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'

export default function projectApprovalSummaryForStaff() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getProjectApprovalSummaryForStaff(proposalId)

      setSchema(_schema)
    } catch (e) {
      console.log('error', e)
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    console.log('load ProjectName projectId', projectId)

    projectId && handleGetSchema(projectId)
  }, [])

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} />

          <ProjectBasicInfo schema={schema.projectInfo} />
          <br />
          <Panel shaded header={schema.summaryResult.header} bordered collapsible defaultExpanded>
            <Grid fluid>
              <Row>
                <Col lg={24} md={24} sm={24} xs={24}>
                  <label>{schema.summaryResult.summaryResult.subHeader} : </label>
                  <label>
                    <b>{schema.summaryResult.summaryResult.value}</b>
                  </label>
                </Col>
                <Col lg={24} md={24} sm={24} xs={24} style={{ marginTop: 10 }}>
                  <label>{schema.summaryResult.discription.subHeader} : </label>
                  <label>
                    <b>{schema.summaryResult.discription.value}</b>
                  </label>
                </Col>
              </Row>
            </Grid>
          </Panel>
        </SidebarProposal>
      )}
    </>
  )
}
